import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const res = await axios.get(`${API_URL}/users/auth/status`, { withCredentials: true });
      setUser(res.data.user || null);
      setIsAuthenticated(!!res.data.user);
    } catch (err) {
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (credentials) => {
    // credentials: { email, password } oder wie du es nutzt
    const res = await axios.post(`${API_URL}/users/login`, credentials, { withCredentials: true });
    // Cookie ist gesetzt, jetzt Auth-Status aktualisieren
    await checkAuth();
    return res;
  };

  const logout = async () => {
    try {
      await axios.get(`${API_URL}/users/logout`, { withCredentials: true });
    } finally {
      // auch bei Fehler Zustand zurücksetzen
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, loading, checkAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}